import React from 'react';

const DownArrowIcon = () => {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
      <path d="M6.00011 13.0001L6.00011 1M6.00011 13.0001L11.0001 8M6.00011 13.0001L1 8" stroke="#222739" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default DownArrowIcon;